var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-launcher-container", {
    attrs: {
      "user-id": _vm.userId,
      "multi-user-id": _vm.multiUserId,
      "is-ready": _vm.isReady,
    },
    on: {
      "sign-out": function ($event) {
        return _vm.$emit("sign-out")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }